import React from 'react';
interface StoreLocatorProps {
  storeLocatorType: string;
  title: string;
}

const StoreLocatorTitle: React.FC<StoreLocatorProps> = ({ storeLocatorType, title }) => (
  <p className={`store-locator-pdp-title ${storeLocatorType === 'bopis' ? 'bopis' : ''}`}>
    {storeLocatorType === 'bopis' && <span className="alo-location-pin-icon"></span>}
    {title}
  </p>
);

export default StoreLocatorTitle;
